// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2oyV6","buttons":"Footer_buttons__3rmiq"};